import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElephantUi = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--background-complete--inject-82",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					y: 382.4,
					width: 500,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 416.78,
					y: 398.49,
					width: 33.12,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 322.53,
					y: 401.21,
					width: 8.69,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 396.59,
					y: 389.21,
					width: 19.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 52.46,
					y: 390.89,
					width: 43.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 104.56,
					y: 390.89,
					width: 6.33,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.47,
					y: 395.11,
					width: 93.68,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "424.6 174.62 415.4 174.62 411.85 211.35 428.15 211.35 424.6 174.62",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "415.4 152.24 424.6 152.24 428.15 115.5 411.85 115.5 415.4 152.24",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 420,
					cy: 192.85,
					r: 8.3,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 417.6,
					y: 178.04,
					width: 4.81,
					height: 28,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 411.24,
					y: 148.73,
					width: 17.52,
					height: 30.62,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "84.6 174.62 75.4 174.62 71.85 211.35 88.15 211.35 84.6 174.62",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "75.4 152.24 84.6 152.24 88.15 115.5 71.85 115.5 75.4 152.24",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 80,
					cy: 192.85,
					r: 8.3,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 77.6,
					y: 178.04,
					width: 4.81,
					height: 28,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 71.24,
					y: 148.73,
					width: 17.52,
					height: 30.62,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.14,322.33c-1.59-2.62-4.21-.34-4.21-.34.37-5-4.25-8.47-4.25-8.47s5.37,0,6.12-5.12-1.87-2.75-4.34-2.78-5,7.15-1.78,11.2,2.37,10.94-5.12,17.58a14.58,14.58,0,0,0-3.91,6.11c.56-6.1.88-14.69-.91-20.43-3-9.74,2.76-12.36,4.44-17.24s-4.44-9-4.44-9,5.75-2.62,2.94-5.62-8.61-2.59-8.61,1.33S68,295,68,295s4.5,4.68,4.5,7.12-4.5,7.68-4.5,7.68,2.06-4.49-2.06-4.68-5.43,5.24-3.75,7.67,4.5.38,4.5.38A47.71,47.71,0,0,0,68,321.58c.42,1.4.22,6.89-.13,12.61a14.29,14.29,0,0,0-3.65-5.41c-7.5-6.64-8.37-13.54-5.12-17.58S59.75,300,57.29,300s-5.08-2.35-4.33,2.78,6.12,5.12,6.12,5.12-4.63,3.44-4.25,8.47c0,0-2.62-2.28-4.22.34-2.84,4.68,3.75,7.59,4.86,5.28,0,0,14,9.89,10.6,24.13l.78,1.16-.16,1.84,1.09-.47L69,350.48a42.16,42.16,0,0,0,.31,6.19l3.34-4.93c-3.37-14.24,10.61-24.13,10.61-24.13C84.39,329.92,91,327,88.14,322.33Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.14,322.33c-1.59-2.62-4.21-.34-4.21-.34.37-5-4.25-8.47-4.25-8.47s5.37,0,6.12-5.12-1.87-2.75-4.34-2.78-5,7.15-1.78,11.2,2.37,10.94-5.12,17.58a14.58,14.58,0,0,0-3.91,6.11c.56-6.1.88-14.69-.91-20.43-3-9.74,2.76-12.36,4.44-17.24s-4.44-9-4.44-9,5.75-2.62,2.94-5.62-8.61-2.59-8.61,1.33S68,295,68,295s4.5,4.68,4.5,7.12-4.5,7.68-4.5,7.68,2.06-4.49-2.06-4.68-5.43,5.24-3.75,7.67,4.5.38,4.5.38A47.71,47.71,0,0,0,68,321.58c.42,1.4.22,6.89-.13,12.61a14.29,14.29,0,0,0-3.65-5.41c-7.5-6.64-8.37-13.54-5.12-17.58S59.75,300,57.29,300s-5.08-2.35-4.33,2.78,6.12,5.12,6.12,5.12-4.63,3.44-4.25,8.47c0,0-2.62-2.28-4.22.34-2.84,4.68,3.75,7.59,4.86,5.28,0,0,14,9.89,10.6,24.13l.78,1.16-.16,1.84,1.09-.47L69,350.48a42.16,42.16,0,0,0,.31,6.19l3.34-4.93c-3.37-14.24,10.61-24.13,10.61-24.13C84.39,329.92,91,327,88.14,322.33Z",
					style: {
						fill: "#e0e0e0",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "85.41 383.06 53.4 383.06 49.95 348.02 88.86 348.02 85.41 383.06",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 48.24,
					y: 344.15,
					width: 42.33,
					height: 7.73,
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M421.19,350.67c0-.35-1.19-35.11-6.84-40.61-5.5-5.34-11.81-.2-12.08,0l-.57-.67c.07-.06,7.2-5.88,13.26,0,5.91,5.74,7.07,39.76,7.11,41.21Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M421.67,357.5c0-.42-3.86-41.73,11.23-59l.66.58c-14.83,17-11.05,58-11,58.37Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M421.12,353.13l-.89-.06c0-.47,2.95-47-8.11-57.14l.6-.65C424.09,305.74,421.24,351.2,421.12,353.13Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M422.56,353.1h-.89c0-1.28.37-31.4,8.92-36.3a6,6,0,0,1,5.54-.54c5.17,2.14,7.74,11.34,7.85,11.73l-.86.24c0-.09-2.56-9.18-7.33-11.16a5.25,5.25,0,0,0-4.76.49C422.91,322.21,422.56,352.79,422.56,353.1Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M419.22,353.12l-.88-.05c0-.23,1.29-23.8-5.07-32.11-1.54-2-3.21-3-5-2.84-4.17.29-7.66,6.39-7.7,6.45l-.77-.44c.15-.27,3.76-6.57,8.41-6.9,2.07-.14,4,.93,5.74,3.2C420.53,329,419.28,352.14,419.22,353.12Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M420.62,356.33c-.18-2.29-4.16-56.1,2.85-65.58l.71.52c-6.81,9.22-2.72,64.44-2.68,65Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M438,321.7s-4.21,1.55-3,5.21,14.55,9.69,14.55,9.69,5.57-5.11.46-13.41S438.15,319.08,438,321.7Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M419.75,314.73s4.48-.19,4.74,3.67-9.71,14.54-9.71,14.54-7.1-2.57-5.58-12.2S418.64,312.36,419.75,314.73Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416,296.25s3-.32,2.75-2.14-11.61-6.5-18.32,1.07c0,0,4.29,7.38,10.5,7.48S416,296.25,416,296.25Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M421.52,291.84s-2.7,1.3-3.46-.37,6.42-11.65,16.11-8.78c0,0,.26,8.54-5,11.9S421.52,291.84,421.52,291.84Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.39,320.23s2.06-1.67-.17-2.48S394.09,317.17,394,328c0,0,12.71,2.11,14.29-2S407.39,320.23,407.39,320.23Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M433.3,296s-2.06-1.66.17-2.47,13.13-.59,13.25,10.22c0,0-12.71,2.12-14.28-2S433.3,296,433.3,296Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M426.59,304.69s-.19-2,1.45-1.23,7.32,6.93,1.42,12.75c0,0-7.94-5.87-6.51-8.94S426.59,304.69,426.59,304.69Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.54,307.57s1.24-1.61-.57-1.81-9.89,2-8,10c0,0,9.85-.74,10.28-4.1S405.54,307.57,405.54,307.57Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "438.82 383.06 405.02 383.06 401.38 346.06 442.47 346.06 438.82 383.06",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 399.57,
					y: 341.98,
					width: 44.7,
					height: 8.17,
					style: { fill: "#e6e6e6" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Shadow--inject-82",
			children: /* @__PURE__ */ _jsx("ellipse", {
				id: "freepik--path--inject-82",
				cx: 250,
				cy: 416.24,
				rx: 193.89,
				ry: 11.32,
				style: { fill: "#f5f5f5" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Window--inject-82",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 104.41,
					y: 94.75,
					width: 291.17,
					height: 187.26,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "395.58 285.53 395.58 259.62 394.27 259.62 394.27 256.76 389.04 256.76 389.04 246.78 386.19 246.78 386.19 240.12 382.86 240.12 382.86 230.14 381.43 230.14 381.43 240.12 378.11 240.12 378.11 246.78 375.25 246.78 375.25 256.76 370.02 256.76 370.02 259.62 367.65 259.62 367.65 270.55 364.79 270.55 364.79 256.76 359.57 256.76 359.57 226.34 358.14 226.34 358.14 223.01 346.73 223.01 346.73 226.34 344.35 226.34 344.35 248.21 334.85 248.21 334.85 250.58 331.52 250.58 331.52 252.01 334.85 252.01 334.85 260.57 324.86 260.57 324.86 232.04 322.96 232.04 322.96 226.34 318.21 226.34 318.21 204.47 316.78 204.47 316.78 226.34 313.45 226.34 313.45 232.04 293.96 232.04 293.96 230.14 293.01 230.14 293.01 243.93 290.16 243.93 290.16 257.71 288.73 257.71 288.73 261.04 284.93 261.04 284.93 251.06 283.98 251.06 283.98 274.83 282.55 274.83 282.55 264.85 281.12 264.85 281.12 280.53 280.65 280.53 280.65 269.6 278.27 269.6 278.27 266.75 273.04 266.75 273.04 256.76 271.82 256.76 271.82 233.94 268.02 233.94 268.02 229.11 259.46 225.11 259.46 220.16 258.04 220.16 258.04 233.94 256.61 233.94 256.61 266.75 254.71 266.75 254.71 251.53 250.43 251.53 250.43 241.55 249 241.55 249 270.55 245.68 270.55 245.68 259.62 243.3 259.62 243.3 256.76 238.07 256.76 238.07 246.78 235.22 246.78 235.22 240.12 231.89 240.12 231.89 230.14 230.46 230.14 230.46 240.12 227.13 240.12 227.13 246.78 224.28 246.78 224.28 256.76 219.05 256.76 219.05 259.62 216.68 259.62 216.68 270.55 213.82 270.55 213.82 256.76 208.59 256.76 208.59 226.34 207.17 226.34 207.17 223.01 195.76 223.01 195.76 226.34 193.38 226.34 193.38 248.21 183.87 248.21 183.87 250.58 180.55 250.58 180.55 252.01 183.87 252.01 183.87 260.57 173.89 260.57 173.89 232.04 171.99 232.04 171.99 226.34 167.23 226.34 167.23 204.47 165.81 204.47 165.81 226.34 162.48 226.34 162.48 232.04 142.99 232.04 142.99 230.14 142.04 230.14 142.04 243.93 139.19 243.93 139.19 257.71 137.76 257.71 137.76 261.04 133.96 261.04 133.96 251.06 133.01 251.06 133.01 274.83 131.58 274.83 131.58 264.85 130.15 264.85 130.15 280.53 129.68 280.53 129.68 269.6 127.3 269.6 127.3 266.75 122.08 266.75 122.08 256.76 119.22 256.76 119.22 250.11 115.42 250.11 115.42 240.12 114.47 240.12 114.47 250.11 110.66 250.11 110.66 256.76 107.81 256.76 107.81 266.75 104.41 266.75 104.41 285.53 395.58 285.53",
					style: {
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "395.58 241.36 395.58 284.01 104.41 284.01 104.41 238.94 123.91 238.94 123.91 232.76 127.3 232.76 127.3 210.8 128.64 210.8 128.64 232.76 133.37 232.76 133.37 238.94 135.55 238.94 135.55 268.06 145.74 268.06 145.74 259.32 142.1 259.32 142.1 257.62 145.74 257.62 145.74 255.44 155.45 255.44 155.45 233.12 157.87 233.12 157.87 229.72 169.28 229.72 169.28 233.12 170.97 233.12 170.97 263.93 176.31 263.93 176.31 278.25 179.05 278.25 179.05 266.84 181.35 266.84 181.35 263.93 186.69 263.93 186.69 253.98 189.61 253.98 189.61 246.95 193.2 246.95 193.2 236.7 194.49 236.7 194.49 246.95 198.08 246.95 198.08 253.98 201 253.98 201 263.93 206.34 263.93 206.34 266.84 208.64 266.84 208.64 278.25 212.15 278.25 212.15 248.28 213.43 248.28 213.43 258.47 218.04 258.47 218.04 278.25 219.74 278.25 219.74 240.64 221.44 240.64 221.44 226.81 222.65 226.81 222.65 231.7 231.41 235.79 231.41 240.64 235.51 240.64 235.51 270.64 237.24 270.64 237.24 263.6 240.83 263.6 240.83 253.35 242.11 253.35 242.11 263.6 245.71 263.6 245.71 270.64 248.63 270.64 248.63 277.15 254.47 277.15 254.47 261.26 257.27 261.26 257.27 241.48 258.35 241.48 258.35 261.26 260.07 261.26 260.07 264.93 261.06 264.93 261.06 275.12 264.65 275.12 264.65 271.36 266.35 271.36 266.35 257.53 267.37 257.53 267.37 257.29 269.07 257.29 269.07 243.46 270.28 243.46 270.28 245.5 290.19 245.5 290.19 239.31 293.6 239.31 293.6 217.36 294.92 217.36 294.92 239.31 299.65 239.31 299.65 245.5 301.85 245.5 301.85 274.61 312.03 274.61 312.03 265.88 308.39 265.88 308.39 264.18 312.03 264.18 312.03 262 321.73 262 321.73 239.68 324.16 239.68 324.16 236.28 335.56 236.28 335.56 239.68 337.26 239.68 337.26 254.41 341.3 254.41 341.3 259.95 349.21 259.95 349.21 270.49 352.97 270.49 352.97 260.54 355.9 260.54 355.9 253.51 359.49 253.51 359.49 243.26 360.77 243.26 360.77 253.51 364.36 253.51 364.36 260.54 367.29 260.54 367.29 270.49 372.63 270.49 372.63 273.4 374.93 273.4 374.93 277.15 378.43 277.15 378.43 254.84 379.72 254.84 379.72 265.03 384.33 265.03 384.33 277.15 386.03 277.15 386.03 247.2 387.72 247.2 387.72 233.37 388.94 233.37 388.94 238.26 395.58 241.36",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "395.58 241.36 395.58 284.01 104.41 284.01 104.41 238.94 123.91 238.94 123.91 232.76 127.3 232.76 127.3 210.8 128.64 210.8 128.64 232.76 133.37 232.76 133.37 238.94 135.55 238.94 135.55 268.06 145.74 268.06 145.74 259.32 142.1 259.32 142.1 257.62 145.74 257.62 145.74 255.44 155.45 255.44 155.45 233.12 157.87 233.12 157.87 229.72 169.28 229.72 169.28 233.12 170.97 233.12 170.97 263.93 176.31 263.93 176.31 278.25 179.05 278.25 179.05 266.84 181.35 266.84 181.35 263.93 186.69 263.93 186.69 253.98 189.61 253.98 189.61 246.95 193.2 246.95 193.2 236.7 194.49 236.7 194.49 246.95 198.08 246.95 198.08 253.98 201 253.98 201 263.93 206.34 263.93 206.34 266.84 208.64 266.84 208.64 278.25 212.15 278.25 212.15 248.28 213.43 248.28 213.43 258.47 218.04 258.47 218.04 278.25 219.74 278.25 219.74 240.64 221.44 240.64 221.44 226.81 222.65 226.81 222.65 231.7 231.41 235.79 231.41 240.64 235.51 240.64 235.51 270.64 237.24 270.64 237.24 263.6 240.83 263.6 240.83 253.35 242.11 253.35 242.11 263.6 245.71 263.6 245.71 270.64 248.63 270.64 248.63 277.15 254.47 277.15 254.47 261.26 257.27 261.26 257.27 241.48 258.35 241.48 258.35 261.26 260.07 261.26 260.07 264.93 261.06 264.93 261.06 275.12 264.65 275.12 264.65 271.36 266.35 271.36 266.35 257.53 267.37 257.53 267.37 257.29 269.07 257.29 269.07 243.46 270.28 243.46 270.28 245.5 290.19 245.5 290.19 239.31 293.6 239.31 293.6 217.36 294.92 217.36 294.92 239.31 299.65 239.31 299.65 245.5 301.85 245.5 301.85 274.61 312.03 274.61 312.03 265.88 308.39 265.88 308.39 264.18 312.03 264.18 312.03 262 321.73 262 321.73 239.68 324.16 239.68 324.16 236.28 335.56 236.28 335.56 239.68 337.26 239.68 337.26 254.41 341.3 254.41 341.3 259.95 349.21 259.95 349.21 270.49 352.97 270.49 352.97 260.54 355.9 260.54 355.9 253.51 359.49 253.51 359.49 243.26 360.77 243.26 360.77 253.51 364.36 253.51 364.36 260.54 367.29 260.54 367.29 270.49 372.63 270.49 372.63 273.4 374.93 273.4 374.93 277.15 378.43 277.15 378.43 254.84 379.72 254.84 379.72 265.03 384.33 265.03 384.33 277.15 386.03 277.15 386.03 247.2 387.72 247.2 387.72 233.37 388.94 233.37 388.94 238.26 395.58 241.36",
					style: {
						opacity: .4,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M102,91.51V285.26H398V91.51Zm196.46,5V280.26H201.58V96.51ZM107,96.51h91.46V280.26H107ZM393,280.26H301.58V96.51H393Z",
					style: { fill: "#4571FF" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M102,91.51V285.26H398V91.51Zm196.46,5V280.26H201.58V96.51ZM107,96.51h91.46V280.26H107ZM393,280.26H301.58V96.51H393Z",
					style: {
						fill: "#fff",
						opacity: .6000000000000001,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.41,94.75V282H395.58V94.75Zm94,185.51H107V96.51h91.45Zm100,0H201.58V96.51h96.83Zm94.62,0H301.58V96.51H393Z",
					style: {
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.28,125.15a1.85,1.85,0,1,1-1.84-1.84A1.84,1.84,0,0,1,142.28,125.15Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M141.63,125.15a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,141.63,125.15Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M224.11,188.07a1.85,1.85,0,1,1-1.85-1.84A1.85,1.85,0,0,1,224.11,188.07Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M223.46,188.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M371.76,149a1.85,1.85,0,1,1-1.85-1.84A1.85,1.85,0,0,1,371.76,149Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M371.11,149a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M273.66,190.52a1.85,1.85,0,1,1-1.85-1.84A1.85,1.85,0,0,1,273.66,190.52Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M273,190.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,273,190.52Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.32,170.78a1.85,1.85,0,1,1-1.85-1.85A1.85,1.85,0,0,1,130.32,170.78Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.66,170.78a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,129.66,170.78Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M317.17,169.59a1.85,1.85,0,1,1-1.84-1.85A1.84,1.84,0,0,1,317.17,169.59Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M316.52,169.59a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 160.48,
					cy: 144.02,
					r: .92,
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 160.48,
					cy: 144.02,
					r: .6,
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 234.23,
					cy: 127.27,
					r: .92,
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 234.23,
					cy: 127.27,
					r: .6,
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M262.44,174.94a.92.92,0,1,1-.92-.92A.93.93,0,0,1,262.44,174.94Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M262.12,174.94a.6.6,0,1,1-1.2,0,.6.6,0,0,1,1.2,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.33,191.72a.93.93,0,1,1-.92-.92A.92.92,0,0,1,147.33,191.72Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147,191.72a.59.59,0,0,1-.59.6.6.6,0,0,1,0-1.2A.59.59,0,0,1,147,191.72Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M310.91,132.88A.93.93,0,1,1,310,132,.92.92,0,0,1,310.91,132.88Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M310.58,132.88a.59.59,0,0,1-.59.6.6.6,0,1,1,0-1.2A.59.59,0,0,1,310.58,132.88Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M339.83,150.81a.92.92,0,1,1-.92-.93A.92.92,0,0,1,339.83,150.81Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M339.51,150.81a.6.6,0,0,1-1.2,0,.6.6,0,0,1,1.2,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 373.61,
					cy: 180.72,
					r: .92,
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 373.61,
					cy: 180.72,
					r: .6,
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 335.12,
					cy: 207.45,
					r: .92,
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M335.72,207.45a.6.6,0,0,1-1.2,0,.6.6,0,0,1,1.2,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M382.71,133.8a.93.93,0,1,1-.92-.92A.92.92,0,0,1,382.71,133.8Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M382.38,133.8a.59.59,0,0,1-.59.6.6.6,0,0,1,0-1.2A.59.59,0,0,1,382.38,133.8Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M189.06,126.35a.93.93,0,1,1-.92-.92A.92.92,0,0,1,189.06,126.35Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M188.73,126.35a.59.59,0,0,1-.59.6.6.6,0,1,1,0-1.2A.59.59,0,0,1,188.73,126.35Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M182.93,183.31a.92.92,0,1,1-.92-.92A.93.93,0,0,1,182.93,183.31Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M182.61,183.31a.6.6,0,0,1-1.2,0,.6.6,0,0,1,1.2,0Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.49,214.18a.93.93,0,1,1-.92-.92A.93.93,0,0,1,240.49,214.18Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.16,214.18a.59.59,0,0,1-.59.6.6.6,0,0,1-.6-.6.59.59,0,0,1,.6-.59A.58.58,0,0,1,240.16,214.18Z",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "163.69 158.05 168.65 157.23 163.69 156.42 165.33 154.12 163.04 155.77 162.22 150.81 161.4 155.77 159.11 154.12 160.75 156.42 155.79 157.23 160.75 158.05 159.11 160.34 161.4 158.7 162.22 163.66 163.04 158.7 165.33 160.34 163.69 158.05",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "162.87 157.6 165.09 157.23 162.87 156.87 163.61 155.85 162.58 156.58 162.22 154.37 161.85 156.58 160.83 155.85 161.57 156.87 159.35 157.23 161.57 157.6 160.83 158.62 161.85 157.89 162.22 160.1 162.58 157.89 163.61 158.62 162.87 157.6",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M222.73,149.3l7.83-1.28-7.83-1.29c23.65-19.73,53.39-21.31,53.39-21.31-37.71,3.36-54.41,20.28-54.41,20.28l-1.29-7.83-1.29,7.83-3.62-2.59,2.59,3.62L210.28,148l7.82,1.28-2.59,3.62,3.62-2.59,1.29,7.83,1.29-7.83,3.62,2.59Z",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "221.45 148.59 224.94 148.01 221.45 147.44 222.61 145.83 220.99 146.98 220.42 143.49 219.84 146.98 218.23 145.83 219.39 147.44 215.9 148.01 219.39 148.59 218.23 150.2 219.84 149.05 220.42 152.54 220.99 149.05 222.61 150.2 221.45 148.59",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "278.85 137.48 283.81 136.67 278.85 135.85 280.49 133.56 278.2 135.2 277.38 130.24 276.56 135.2 274.27 133.56 275.91 135.85 270.95 136.67 275.91 137.48 274.27 139.78 276.56 138.13 277.38 143.09 278.2 138.13 280.49 139.78 278.85 137.48",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "278.03 137.03 280.25 136.67 278.03 136.3 278.77 135.28 277.74 136.01 277.38 133.8 277.01 136.01 275.99 135.28 276.73 136.3 274.51 136.67 276.73 137.03 275.99 138.06 277.01 137.32 277.38 139.53 277.74 137.32 278.77 138.06 278.03 137.03",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "336.59 178.68 341.55 177.86 336.59 177.04 338.23 174.75 335.94 176.39 335.12 171.43 334.31 176.39 332.01 174.75 333.66 177.04 328.7 177.86 333.66 178.68 332.01 180.97 334.31 179.32 335.12 184.28 335.94 179.32 338.23 180.97 336.59 178.68",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "335.77 178.22 337.99 177.86 335.77 177.49 336.51 176.47 335.49 177.2 335.12 174.99 334.76 177.2 333.74 176.47 334.47 177.49 332.26 177.86 334.47 178.22 333.74 179.25 334.76 178.51 335.12 180.72 335.49 178.51 336.51 179.25 335.77 178.22",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "372.87 214.27 375.48 213.84 372.87 213.41 373.74 212.21 372.53 213.07 372.1 210.46 371.67 213.07 370.46 212.21 371.33 213.41 368.72 213.84 371.33 214.27 370.46 215.48 371.67 214.61 372.1 217.23 372.53 214.61 373.74 215.48 372.87 214.27",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "372.44 214.03 373.61 213.84 372.44 213.65 372.83 213.11 372.29 213.5 372.1 212.33 371.91 213.5 371.37 213.11 371.76 213.65 370.59 213.84 371.76 214.03 371.37 214.57 371.91 214.19 372.1 215.35 372.29 214.19 372.83 214.57 372.44 214.03",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "337.74 128.06 339.51 127.77 337.74 127.48 338.33 126.66 337.51 127.25 337.22 125.48 336.93 127.25 336.11 126.66 336.7 127.48 334.93 127.77 336.7 128.06 336.11 128.88 336.93 128.29 337.22 130.06 337.51 128.29 338.33 128.88 337.74 128.06",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "337.45 127.9 338.24 127.77 337.45 127.64 337.71 127.28 337.35 127.54 337.22 126.75 337.09 127.54 336.73 127.28 336.99 127.64 336.2 127.77 336.99 127.9 336.73 128.26 337.09 128 337.22 128.79 337.35 128 337.71 128.26 337.45 127.9",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "174.23 200.46 176 200.17 174.23 199.88 174.82 199.06 174 199.65 173.71 197.88 173.42 199.65 172.6 199.06 173.19 199.88 171.42 200.17 173.19 200.46 172.6 201.28 173.42 200.69 173.71 202.46 174 200.69 174.82 201.28 174.23 200.46",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "173.94 200.3 174.73 200.17 173.94 200.04 174.2 199.68 173.84 199.94 173.71 199.15 173.58 199.94 173.21 199.68 173.48 200.04 172.69 200.17 173.48 200.3 173.21 200.66 173.58 200.4 173.71 201.19 173.84 200.4 174.2 200.66 173.94 200.3",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "247.37 154.66 249.14 154.37 247.37 154.08 247.96 153.26 247.14 153.85 246.85 152.08 246.56 153.85 245.74 153.26 246.33 154.08 244.56 154.37 246.33 154.66 245.74 155.48 246.56 154.89 246.85 156.66 247.14 154.89 247.96 155.48 247.37 154.66",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "247.08 154.5 247.87 154.37 247.08 154.24 247.34 153.87 246.98 154.13 246.85 153.35 246.72 154.13 246.36 153.87 246.62 154.24 245.83 154.37 246.62 154.5 246.36 154.86 246.72 154.6 246.85 155.39 246.98 154.6 247.34 154.86 247.08 154.5",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "139.72 216.12 142.33 215.69 139.72 215.26 140.59 214.06 139.38 214.92 138.95 212.31 138.52 214.92 137.31 214.06 138.18 215.26 135.56 215.69 138.18 216.12 137.31 217.33 138.52 216.46 138.95 219.08 139.38 216.46 140.59 217.33 139.72 216.12",
					style: {
						fill: "#fff",
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "139.29 215.88 140.46 215.69 139.29 215.5 139.68 214.96 139.14 215.35 138.95 214.18 138.75 215.35 138.22 214.96 138.6 215.5 137.44 215.69 138.6 215.88 138.22 216.42 138.75 216.04 138.95 217.2 139.14 216.04 139.68 216.42 139.29 215.88",
					style: {
						fill: "#fff",
						opacity: .5,
						isolation: "isolate"
					}
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Character--inject-82",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					points: "120.44 391.11 113.71 417.22 118.86 417.22 130.66 391.11 120.44 391.11",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "403.94 391.11 410.66 417.22 405.52 417.22 393.71 391.11 403.94 391.11",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "100.66 391.11 96.24 400.89 88.86 417.22 83.71 417.22 87.92 400.89 90.44 391.11 100.66 391.11",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "87.92 400.89 96.24 400.89 88.86 417.22 83.71 417.22 87.92 400.89",
					style: {
						fill: "#fff",
						opacity: .30000000000000004,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "380.66 417.22 375.52 417.22 368.13 400.89 363.71 391.11 373.94 391.11 376.46 400.89 380.66 417.22",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "380.66 417.22 375.52 417.22 368.13 400.89 376.46 400.89 380.66 417.22",
					style: {
						fill: "#fff",
						opacity: .30000000000000004,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M415.61,351.79H127a5.69,5.69,0,0,1-5.69-5.69V319.87a16.06,16.06,0,0,0-16.06-16.06h-20a16.06,16.06,0,0,0-16,16.06v51.46a25.44,25.44,0,0,0,25.45,25.45H400.71a25.44,25.44,0,0,0,25.45-25.45v-9A10.55,10.55,0,0,0,415.61,351.79Z",
					style: { fill: "#4571FF" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.61,351.79H107a5.69,5.69,0,0,1-5.69-5.69V319.87a16.06,16.06,0,0,0-16.06-16.06h0a16.06,16.06,0,0,0-16,16.06v51.46a25.44,25.44,0,0,0,25.45,25.45H380.71a25.44,25.44,0,0,0,25.45-25.45v-9A10.55,10.55,0,0,0,395.61,351.79Z",
					style: {
						fill: "#fff",
						opacity: .30000000000000004,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M429.2,355.27v7.46a6.1,6.1,0,0,1-6.1,6.09H111.76a6.1,6.1,0,0,1-6.1-6.09v-7.46a6.1,6.1,0,0,1,6.1-6.1H423.1A6.1,6.1,0,0,1,429.2,355.27Z",
					style: { fill: "#4571FF" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.2,355.27v4.36a6.1,6.1,0,0,1-6.1,6.09H111.76a6.1,6.1,0,0,1-6.1-6.09v-4.36a6.1,6.1,0,0,1,6.1-6.1H403.1A6.1,6.1,0,0,1,409.2,355.27Z",
					style: {
						fill: "#fff",
						opacity: .30000000000000004,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M114.89,349.17s15.36,11.53,31.19,9.83c0,0,27.89,6.72,87.62,6.72S349,355.9,349,355.9s14.36,9.22,17.27,12.92c0,0,7.69,9.83,8.47,9.63s20.75-11.75,20.75-11.75,0-.51-1.47-1.9-12.38-1.45-12.38-1.45l-6.34-7.52,17.4-1.91,7.87,2.81s3-7.55,5.57-7.56Z",
					style: {
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M94.78,295.31c-5.29.38-2.64,4.07-2.64,4.07s2.1,24.19,8.83,37.45,31.38,17.26,31.38,17.26,3.39,2.26,4.67,1.73a2.06,2.06,0,0,0,1.32-1.73,48,48,0,0,0,7.44-2.85c2-1.22-6.52-24.05-18.47-32.17C127.31,319.07,114.82,293.88,94.78,295.31Z",
					style: { fill: "#4571FF" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M145.78,351.24a24.36,24.36,0,0,1-3.85,1.66c-1.87.67-3.59,1.19-3.59,1.19a2.06,2.06,0,0,1-1.32,1.73c-1.28.53-4.67-1.73-4.67-1.73s-24.65-4-31.38-17.26-8.83-37.45-8.83-37.45-2.65-3.69,2.64-4.07a19.79,19.79,0,0,1,2-.05c18.85.32,30.5,23.81,30.5,23.81C139.26,327.19,147.79,350,145.78,351.24Z",
					style: {
						fill: "#fff",
						opacity: .6000000000000001,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M145.78,351.24a24.36,24.36,0,0,1-3.85,1.66,21.3,21.3,0,0,0-4.12-5.1C123.05,340.43,114,315.15,114,315.15c-14-3.75-16.81-13.8-17.16-19.89,18.85.32,30.5,23.81,30.5,23.81C139.26,327.19,147.79,350,145.78,351.24Z",
					style: {
						opacity: .2,
						isolation: "isolate"
					}
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "freepik--group--inject-82",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M160.27,267.7l2-8.3a13.6,13.6,0,0,1-1-3.3c.07-.79,4.16-9,5.74-9.23s4.48,3.56,4.88,3.95-2.69,7.92-3.06,8.58-1.82.79-1.82.79l-1,6.29Z",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M135.59,315.57c.47-1.25,13.48-17.95,15.85-24.13s10.29-31.25,10.29-31.25l6.06,1.84s-6.06,26.7-8.17,33.66-13.78,26.51-13.78,26.51Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M167.79,262s-6.06,26.7-8.17,33.66c-.86,2.83-3.29,7.73-5.88,12.56-3.79,7.06-7.9,13.95-7.9,13.95l-10.25-6.63c.2-.54,2.72-3.93,5.71-8.11,4-5.55,8.79-12.5,10.14-16,2.37-6.18,10.29-31.25,10.29-31.25Z",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M153.74,308.25c-3.79,7.06-7.9,13.95-7.9,13.95l-10.25-6.63c.2-.54,2.72-3.93,5.71-8.11A33.38,33.38,0,0,1,153.74,308.25Z",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "393.52 350.23 392.97 342.14 374.18 342.75 374.73 350.85 393.52 350.23",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M392,341.08l.67,9.83a.72.72,0,0,0,.61.65l7.31,1.11a1.2,1.2,0,0,0,1.35-1,1.15,1.15,0,0,0,0-.26c-.27-3.18-.62-5.48-.89-9.47-.17-2.46-.42-9.9-.65-13.3s-3.62-3.61-3.83-2.2c-.94,6.33-2.5,11.15-4.15,13.27A2,2,0,0,0,392,341.08Z",
							style: { fill: "#263238" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M393,340.45a.22.22,0,0,1-.16.16.18.18,0,0,1-.19-.08c-.2-.28-2-2.78-1.58-3.71a.58.58,0,0,1,.51-.37,1.12,1.12,0,0,1,1.05.34,2.34,2.34,0,0,1,.52,1.52A9.56,9.56,0,0,1,393,340.45Zm-.31-.54a3.88,3.88,0,0,0-.34-2.87.79.79,0,0,0-.7-.21c-.16,0-.23.09-.22.14a.44.44,0,0,0,0,.25A7.9,7.9,0,0,0,392.73,339.91Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M393.08,340.5a.23.23,0,0,1-.17.11c-.11,0-2.45,0-3.27-.93a1.08,1.08,0,0,1-.31-.8.64.64,0,0,1,.47-.65c.84-.22,2.73,1.27,3.24,2.08v.09A.17.17,0,0,1,393.08,340.5Zm-3.23-1.08a4.51,4.51,0,0,0,2.59.78c-.68-.79-2.1-1.72-2.62-1.59-.05,0-.19.05-.17.3V339A.62.62,0,0,0,389.85,339.42Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "374.74 350.85 374.19 342.75 383.88 342.44 384.43 350.54 374.74 350.85",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M378.81,352.08s-2.75.28-7.65.72c-6.52.59-16.85-.51-29.58.59-44.51,3-115,14.63-167.85,7.2q3.11-14.5,6.58-29,9.63,1.71,19.14,3.68c0-.18,56.7-4.17,107.75-1.21,23.22,1.06,45.26,3,60.44,4.13,4.46.32,8.33.57,11.45.66Q379,345.47,378.81,352.08Z",
							style: { fill: "#263238" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M378.81,352.08s-2.75.28-7.65.72c-6.52.59-16.85-.51-29.58.59-44.51,3-115,14.63-167.85,7.2q3.11-14.5,6.58-29,9.63,1.71,19.14,3.68c0-.18,56.7-4.17,107.75-1.21,23.22,1.06,45.26,3,60.44,4.13,4.46.32,8.33.57,11.45.66Q379,345.47,378.81,352.08Z",
							style: {
								fill: "#fff",
								opacity: .4,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M371.16,352.8c-6.52.59-16.85-.51-29.58.59-10.7-8-25.53-14.64-34.38-19.33,23.22,1.06,45.26,3,60.44,4.13A27.61,27.61,0,0,1,371.16,352.8Z",
							style: {
								opacity: .4,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M380.13,336.06q1.88,8.58,3.62,17.18l-5.25,1q-2-8.88-4.22-17.74C376.23,336.34,378.18,336.2,380.13,336.06Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M380.13,336.06q1.88,8.58,3.62,17.18l-5.25,1q-2-8.88-4.22-17.74C376.23,336.34,378.18,336.2,380.13,336.06Z",
							style: {
								fill: "#fff",
								opacity: .6000000000000001,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "131.03 284.01 134.6 285.61 133.85 288.43 131.03 284.01",
							style: { fill: "#d58745" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M136.68,294.64c.1.43.18.86.24,1.28a12.24,12.24,0,0,1-1.22,7.14,12.5,12.5,0,0,1-1,1.61,11.07,11.07,0,0,1-8.27,4.73,11.19,11.19,0,0,1-4.39-.58c-5.95-1.94-8.19-6.56-12.61-14.06a11.93,11.93,0,0,1,9.19-18.1C127.82,275.85,134.78,286.82,136.68,294.64Z",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M135.7,303.06a12.5,12.5,0,0,1-1,1.61,11.07,11.07,0,0,1-8.27,4.73,12.77,12.77,0,0,1,0-3.34A17.14,17.14,0,0,1,135.7,303.06Z",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M126.82,325.22c5.58,1.5,15.53-2.24,15.53-2.24V312.92c-3.72,1.2-6.15-1.73-7.89-3.43a11.39,11.39,0,0,1-2.37-3.74,23,23,0,0,1-.83-2.33L114,303.06C125.1,311.65,128.44,319.22,126.82,325.22Z",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M121.32,273.65c-5.19-1.49-6.59.81-6.59.81-3.91-1.64-12.15,5.42-13.8,11.87s1.56,13,5.52,16.95c5.78,5.75,15.07,8.58,15.07,8.58l-2.11-1.18c5.94-3,11.15-6.39,9.22-9.21s-1-7-1-7c3.07-1.29,2.89-5.82,2.89-5.82s.6-4.74-3-7.38S125.68,274.91,121.32,273.65Z",
							style: { fill: "#263238" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M125.26,293.57a5.6,5.6,0,0,0,4.34,2.11c1.92-.14,1.81-2.89.39-5.1-1.28-1.95-3.84-4.3-5.32-3.05S123.64,291.78,125.26,293.57Z",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M124.88,277.84s1.48-6.93-4-9.1-9.69,2.37-9.69,2.37a5.62,5.62,0,0,1,3.66-.69s-9.1.79-13.25,10.88c0,0,2.27-3.07,5.24-3.56,0,0-7.42,5.14-8,11.87s.1,10.78,8.5,13.15S124.88,277.84,124.88,277.84Z",
							style: { fill: "#263238" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M124.88,277.84s1.48-6.93-4-9.1-9.69,2.37-9.69,2.37a5.62,5.62,0,0,1,3.66-.69s-9.1.79-13.25,10.88c0,0,2.27-3.07,5.24-3.56,0,0-7.42,5.14-8,11.87s.1,10.78,8.5,13.15S124.88,277.84,124.88,277.84Z",
							style: {
								fill: "#fff",
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "371.82 366.7 376.2 359.88 360.76 349.17 356.37 356 371.82 366.7",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M376,358.43l-5.32,8.29a.71.71,0,0,0,.09.88l5.21,5.25a1.2,1.2,0,0,0,1.7,0,1.56,1.56,0,0,0,.16-.2c1.68-2.71,2.77-4.77,4.93-8.14,1.33-2.07,5.57-8.19,7.4-11.06s-.75-5.05-1.76-4.05c-4.52,4.53-8.65,7.47-11.24,8.18A2,2,0,0,0,376,358.43Z",
							style: { fill: "#263238" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M377.27,358.57a.22.22,0,0,1-.22,0,.17.17,0,0,1-.11-.18c0-.34.06-3.42.94-3.92a.58.58,0,0,1,.63,0,1.15,1.15,0,0,1,.65.9,2.42,2.42,0,0,1-.5,1.53A9.82,9.82,0,0,1,377.27,358.57Zm.07-.62a3.91,3.91,0,0,0,1.44-2.51.83.83,0,0,0-.44-.59c-.14-.07-.23-.06-.26,0a.39.39,0,0,0-.18.18A8,8,0,0,0,377.34,358Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M377.27,358.63a.23.23,0,0,1-.2,0c-.09-.07-1.94-1.5-2.08-2.7a1,1,0,0,1,.24-.82.63.63,0,0,1,.76-.25c.8.33,1.43,2.65,1.36,3.6l-.05.08A.17.17,0,0,1,377.27,358.63Zm-1.95-2.8a4.47,4.47,0,0,0,1.62,2.18c-.08-1-.66-2.64-1.16-2.84,0,0-.18-.08-.32.13l0,.08A.65.65,0,0,0,375.32,355.83Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "356.38 356 360.77 349.18 368.73 354.7 364.34 361.53 356.38 356",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M368,349.94,361,361.21s-58.89-32.58-71.85-34.36c-1.44-.19-3.52.35-6.16,1.41a113.19,113.19,0,0,0-10.46,5.16h0c-2.32,1.25-4.81,2.63-7.44,4.08h0c-26.48,14.59-67.28,36.71-95.4,16.51l9.54-25.54,16.7.89s58.07-22.41,84.71-24.59S368,349.94,368,349.94Z",
							style: { fill: "#263238" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M368,349.94,361,361.21s-58.89-32.58-71.85-34.36c-1.44-.19-3.52.35-6.16,1.41a113.19,113.19,0,0,0-10.46,5.16h0c-2.32,1.25-4.81,2.63-7.44,4.08h0c-26.48,14.59-67.28,36.71-95.4,16.51l9.54-25.54,16.7.89s58.07-22.41,84.71-24.59S368,349.94,368,349.94Z",
							style: {
								fill: "#fff",
								opacity: .4,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "370.39 349.23 360.94 363.95 356.54 361.12 366.06 345.66 370.39 349.23",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "370.39 349.23 360.94 363.95 356.54 361.12 366.06 345.66 370.39 349.23",
							style: {
								fill: "#fff",
								opacity: .6000000000000001,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M289.1,326.85c-1.44-.19-3.52.35-6.16,1.41a113.19,113.19,0,0,0-10.46,5.16h0c-.57,0-23.89,1.53-41.8,2.93C230.67,336.35,273.16,322.72,289.1,326.85Z",
							style: {
								opacity: .4,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M107.22,301.11s-5,.47-5.83,1.7,5.55,8.18,5.55,8.18,3.48.18,4.11-1.2-.29-4.76-.29-4.76Z",
							style: { fill: "#ebb376" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M179.44,363.35c-51.28-10.15-54.08-34.37-53.39-38.07,1.2-6.35,9.94-14.44,21.46-11.91,13.16,2.89,23.1,9.52,42.06,14Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M179.44,363.35c-51.28-10.15-54.08-34.37-53.39-38.07,1.2-6.35,9.94-14.44,21.46-11.91,13.16,2.89,23.1,9.52,42.06,14Z",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M137.81,317.29s-14.91-25.87-22.29-26.86-9.86,12-9.86,12,2.18,6.08,5.56,5.13c0,0,1.38-3.45,4.29-3.3S127,331.89,127,331.89,136.73,329.62,137.81,317.29Z",
							style: { fill: "#4571FF" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M137.81,317.29s-14.91-25.87-22.29-26.86-9.86,12-9.86,12,2.18,6.08,5.56,5.13c0,0,1.38-3.45,4.29-3.3S127,331.89,127,331.89,136.73,329.62,137.81,317.29Z",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M136.06,314.32a10.06,10.06,0,0,1,5.23,6.26c1.31,4.62-3.7,9.5-3.7,9.5A20.47,20.47,0,0,0,136.06,314.32Z",
							style: {
								opacity: .2,
								isolation: "isolate"
							}
						})
					]
				})
			]
		})
	]
});
export default SvgElephantUi;
